

































































import { Component, Mixins, Prop } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";
import { EDSConfig } from "~/eds.type";
import {
  NCALayerModes,
  NCALayerStatuses,
  TYPES_OF_STORAGE,
} from "@/config/consts";
import { SignService } from "@/services/sign.service";
import { translateSelectorItems } from "@/utils";
import SignEDSCard from "@/components/EDS/SignEDSCard.vue";

@Component({
  components: { SignEDSCard },
})
export default class EDSDialog extends Mixins(FormValidator) {
  showStorageTypeDialog: boolean = false;

  resolvedPromise: any = null;
  dataToSign = {};
  options: EDSConfig | undefined = {
    signKey: "SIGNATURE",
    signMethod: "signXml" as NCALayerModes,
    validate: true,
    signDocumentName: {
      id: 1,
      nameEn: "Документ",
      nameRu: "Документ",
      nameKz: "Документ",
    },
  };
  loading: boolean = false;

  get signDocumentName() {
    return this.options?.signDocumentName;
  }

  async sign(data: any, options?: EDSConfig) {
    return new Promise(resolve => {
      this.resolvedPromise = resolve;
      this.dataToSign = data;
      this.options = options;
      this.showStorageTypeDialog = true;
    });
  }

  errorMessage? = "";
  // async signData() {
  //   this.loading = true;
  //   const { result, message } = await SignService.sign(
  //     this.selectedStorageType,
  //     this.dataToSign as string,
  //     this.options as EDSConfig,
  //   );
  //   if (message == "NCALayer: action.canceled") {
  //     this.resolvedPromise(result);
  //     this.closeWindow();
  //   }
  //   this.errorMessage =
  //     message == "NCALayer: action.canceled" ||
  //     message == "NCALayer: storage.empty"
  //       ? ""
  //       : message;
  //   this.resolvedPromise(result);
  //   this.loading = false;
  //   if (result) this.closeWindow();
  // }

  async complete(storage: any) {
    this.loading = true;
    const EDSRequest = await SignService.sign(
      storage,
      this.dataToSign as string,
      this.options as EDSConfig,
    );
    // TODO: Проверить сервис возвращает ли она message
    if (!EDSRequest) return;
    const { result, message } = EDSRequest;
    if (
      typeof message == "string" &&
      !message?.includes(NCALayerStatuses.ACTION_CANCELED)
    ) {
      // this.errorMessage = this.$t(`edsModal.errors.${message}`) as string;
    }
    // if (message == "NCALayer: action.canceled") {
    //   this.resolvedPromise(result);
    //   this.closeWindow();
    // }
    // this.errorMessage =
    //   message == "NCALayer: action.canceled" ||
    //   message == "NCALayer: storage.empty"
    //     ? ""
    //     : message;
    this.resolvedPromise(result);
    this.loading = false;
    if (result) this.closeWindow();
  }

  async qrComplete(result: string) {
    this.resolvedPromise(result);
    this.loading = false;
    if (result) this.closeWindow();
  }

  public closeWindow() {
    this.loading = false;
    this.errorMessage = null as any;
    this.options = undefined;
    this.dataToSign = {};
    this.showStorageTypeDialog = false;
    this.resolvedPromise = undefined;
  }
}
